import React from 'react'
import {
  Body,
  Button,
  Card,
  Grid,
  HorizontalSpacer,
  Icon,
  Link,
  Lockup,
  PageSection as Section,
  TextVerticalSpacer,
} from '@superhi/design'

import { Separator } from './styles'
import SignUpModal from './components/SignUpModal'
import { PlanType } from './components/SignUpModal/types'

import BackgroundImageWarped from 'src/components/BackgroundImageWarped'
import { buildPath } from 'src/routing'

const DATA = [
  {
    title: 'Standard',
    description: 'Suitable for teams of 10 or less',
    planType: 'standard' as PlanType,
    points: [
      <>
        <Link href={buildPath('membership-product')}>SuperHi Unlimited </Link>
        <span>for each member of the team</span>
      </>,
      'Tailored learning plan for each member',
      'Admin panel for HR/L+D depts (coming soon)',
      'Single sign-on (coming soon)',
    ],
  },
  {
    title: 'Enterprise',
    description: 'Suitable for teams of 11+',
    planType: 'enterprise' as PlanType,
    points: [
      <strong key={1}>All of the standard plan features</strong>,
      'Custom lessons, exclusively created for your team',
      'Custom live workshops',
      'Support with technical hiring',
    ],
  },
]

const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: [2, 7],
  large: [2, 6],
}
const GRID_1_CELL_SPAN_2: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: [2, 7],
  large: [7, 11],
}

export const ID = 'plans'

const BACKGROUND_IMAGE_OPTIONS: React.ComponentProps<typeof BackgroundImageWarped>['options'] = {
  small: {
    ar: '50:100',
    fit: 'crop',
    crop: 'bottom',
  },
  medium: {
    ar: '75:100',
    fit: 'crop',
    crop: 'bottom',
  },
  large: {
    ar: '100:50',
    fit: 'crop',
    crop: 'bottom',
  },
  xlarge: {
    ar: '125:50',
    fit: 'crop',
    crop: 'bottom',
  },
}

const Plans = () => {
  const [modalIsOpen, setModalIsOpen] = React.useState(false)
  const [planType, setPlanType] = React.useState<PlanType>('standard')

  return (
    <BackgroundImageWarped color="blue" position="top center" options={BACKGROUND_IMAGE_OPTIONS}>
      <Section
        id={ID}
        title="Our plans"
        subtitle="We have two core plans which we're more than happy to tailor to your business. Just let us know your needs!"
        backgroundColor="transparent"
      >
        <Grid alignItems="stretch">
          {DATA.map((item, i) => (
            <Grid.Cell key={item.title} span={i % 2 ? GRID_1_CELL_SPAN_2 : GRID_1_CELL_SPAN_1}>
              <Card level="1" elevated={false}>
                <TextVerticalSpacer>
                  <Lockup level="3" title={item.title} subtitle={item.description} align="left" />

                  <Separator />

                  <TextVerticalSpacer level="3">
                    {item.points.map((point, i) => (
                      <HorizontalSpacer key={i} amount={{ small: 8, medium: 8, large: 8 }}>
                        <div>
                          <Icon name="check" color="BLUE_50" />
                        </div>
                        <Body level="3">{point}</Body>
                      </HorizontalSpacer>
                    ))}
                  </TextVerticalSpacer>

                  <Button
                    fullWidth
                    onClick={() => {
                      setPlanType(item.planType)
                      setModalIsOpen(true)
                    }}
                  >
                    Get started
                  </Button>
                </TextVerticalSpacer>
              </Card>
            </Grid.Cell>
          ))}
        </Grid>
      </Section>
      {modalIsOpen && <SignUpModal onClose={() => setModalIsOpen(false)} planType={planType} />}
    </BackgroundImageWarped>
  )
}

export default Plans
